import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailsService } from '../details.service';
import { AssignedContact, CallDetail } from '../../contacts/shared/models/Contact';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import * as moment from 'moment';
import { getLimitsSelector } from '../../shared/limits/limits.reducer';
import { AccountLimits } from '../../account/account.model';
import { hideRecordingsNotAvailableInPlan } from '../../shared/limits/limitsHelper';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';

@Component({
  selector: 'cc-call-details',
  templateUrl: './call-details.component.html',
  styleUrls: ['./call-details.component.scss']
})
export class CallDetailsComponent implements OnInit, OnDestroy {
  public eventId: number;
  public recordUrl: string;
  public event: CallDetail;
  public assignedContacts: AssignedContact[];
  public voiceMailFileName: string;
  public spinnerVisible: boolean;
  public recordingEvents = [
    'REFUSE',
    'INCOMING_CALL',
    'INCOMING_CALL_ANSWERED',
    'INCOMING_CALL_REDIRECTED',
    'INCOMING_CALL_NOT_ANSWERED',
    'CONFERENCE_CALL',
    'TRANSFER_CALL'
  ];
  private recordingsStorageDays = 0;
  private eventFetchTimeoutId = null;

  constructor(public detailsService: DetailsService, private store: Store<IState>) {}

  ngOnInit() {
    this.detailsService.onSetEventId.subscribe(id => {
      this.eventId = id;
    });
    this.store.select(getLimitsSelector).subscribe((limits: AccountLimits) => {
      this.recordingsStorageDays = limits.recordingsStorageDays;
    });
    this.loadEvent();
  }

  ngOnDestroy() {
    if (this.eventFetchTimeoutId) {
      window.clearTimeout(this.eventFetchTimeoutId);
    }
  }

  loadEvent() {
    this.detailsService.getCallDetails(this.eventId).subscribe((event: CallDetail) => {
      this.event = hideRecordingsNotAvailableInPlan(this.recordingsStorageDays, event);
      this.event = { ...this.event, name: event.contactName, surname: event.contactSurname };
      this.spinnerVisible = this.event.answered && !this.event.recordingExists;
      if (this.event && this.event.contacts) {
        this.assignedContacts = this.event.contacts.map(item => {
          const contactNumber = this.getEmphasizedNumber(item.alternativeMsisdns);
          const parsedNumber = parsePhoneNumberFromString(contactNumber);

          return {
            ...item,
            extendedMsisdns: {
              msisdn: contactNumber ? this.detailsService.getFormatedNumber(contactNumber) : null,
              isoCountry:
                contactNumber && parsedNumber && parsedNumber.country ? parsedNumber.country.toLowerCase() : null
            }
          };
        });
      }
      if (this.event && this.event.id) {
        this.recordUrl = this.detailsService.getRecordingUrl(this.event.id);
        this.voiceMailFileName = this.detailsService.createVoicemailFilename(this.event);
      }
      this.event.startDate = moment(this.event.startDate).format('LTS,  L');
    });

    if (!this.event || (this.event && !this.event.recordingExists)) {
      this.eventFetchTimeoutId = setTimeout(() => {
        this.loadEvent();
      }, 20000);
    }
  }

  getEmphasizedNumber(list, compareNumber = this.event.msisdn) {
    if (compareNumber) {
      return list.filter(number => number === compareNumber)[0];
    } else {
      return list[0];
    }
  }
}
